
  import { Component, Vue } from "vue-property-decorator";
  import SolicitaAtencion from "@/components/Municipalidad/SolicitaAtencion.vue";
  
  @Component({
    components: {
        SolicitaAtencion
    }
  })
  export default class SolicitaAtencionView extends Vue {}
  